import React, { useEffect } from 'react';
import "./services.css"
import Aos from "aos";
import "aos/dist/aos.css";

import Screen from "@material-ui/icons/ComputerOutlined";
import Web from "@material-ui/icons/WebAssetOutlined";
import Facebuk from "@material-ui/icons/Facebook";
import Google from "@material-ui/icons/GTranslateOutlined";


function Services() {

  useEffect(() => {
    Aos.init({duration: 2000});
}, [])

    return (
        <div id="service" className="servy">
            <h2 data-aos="fade-up" className="kkk" >SERVICES</h2>
        <div className="services">
            <div className="part">
               <div className="bango">
               <div data-aos="fade-down"  className="zero">
                 <Screen style={{color: "white", marginLeft: "25%", transform: "scale(1.5)"}}/>
               </div>
               <h2 data-aos="fade-up" className="colo" >WEB DESIGN</h2>
               <p>tunabuni miundo ya websites zenye muonekano wa kisasa unaovutia makini ya wateja
               </p>
               </div>

                <div className="bango">
               <div data-aos="fade-down" className="zero">
                 <Web style={{color: "white",  marginLeft: "25%", transform: "scale(1.5)"}} />
               </div>
               <h2>Web Development</h2>
               <p>tunatengeneza websites nzuri za kisasa zenye viwango vya hali ya juu
               </p>
                </div>
            </div>

            <div className="part">
                <div className="bango">
               <div data-aos="fade-down" className="zero">
                 <Facebuk style={{color: "white",  marginLeft: "25%", transform: "scale(1.5)"}} />
               </div>
               <h2>Facebook Ads SMM</h2>
               <p>tunatengeneza matangazo ya facebook yatakayoweza kutangaza website yako kwa watu wote
               </p>
                </div>

                <div className="bango">
               <div data-aos="fade-down" className="zero">
                 <Google style={{color: "white",  marginLeft: "25%", transform: "scale(1.5)"}}/>
               </div>
               <h2>Google Ads</h2>
               <p>huduma zako zitatokea juu kwenye engine tafuti ya google 
               </p>
                </div>
            </div>
        </div>
        </div>
    )
}

export default Services
